/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Nbstatechangep23Inputs */



/**
* | output |
* | --- |
* | "Number of state changes (right/bottom pump)" |
*
* @param {Ahu_History_Key_Nbstatechangep23Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_nbstatechangep23 = /** @type {((inputs?: Ahu_History_Key_Nbstatechangep23Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Nbstatechangep23Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Number of state changes (right/bottom pump)")
	return /** @type {LocalizedString} */ ("Nombre de changements d'état pompe droite/basse")
});
export { ahu_history_key_nbstatechangep23 as "ahu_history_key_nbStateChangeP2" }